<template>

  <div style="max-width:650px;margin:0px auto;padding-top:25px;">
<h3>Location Details</h3>
<v-card class='mt-5 mb-10' elevation="2">
    <v-card-text>
      <h3>Main Info</h3>
    
      <div><v-text-field label="Name" v-model="location.title"></v-text-field></div>
   

</v-card-text>
<v-card-actions >
<v-btn @click="save" text :disabled="different">Save</v-btn>
</v-card-actions>

</v-card>




</div>
</template>

<script>
import FileSaver from 'file-saver'
import axios from 'axios';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';

dayjs.extend(relativeTime);
dayjs.extend(utc);

  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'Home',
data: function(){
  return {location:{}}
},
created: function () {
    // `this` points to the vm instance
    var t = this;
    t.location = JSON.parse(JSON.stringify(this.getLocationByID(t.$route.params.id)));


  },



computed:{
     ...mapGetters(["getAxiosConfig","getAxiosConfigBlob","returnAccount","getLocationByID"]),

      different: function(){
        var t = this;
        return JSON.stringify(this.location)==JSON.stringify(this.getLocationByID(t.$route.params.id));
      }
},

    components: {

    },
      methods: {
      
      save: function(){
var  t= this;

          this.updateLocation(
  {UpdateLocationDTO:{"newTitle": this.location.title},
  LocationID: this.$route.params.id
}).then(response=>{

  if(response==1){
    t.$router.push({ path: `/admin/venue/${t.$route.params.id}` })
  }

});
      },
        ...mapActions([
      "returnLocationCheckIns",
      "returnQRCodes",
      "addQRCode",
      "getToken",
      "updateLocation"
          ]),

  }
  }
</script>
